"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.WORD_AND_POWERPOINT_MIME_TYPES = exports.WORD_AND_PDF_MIME_TYPES = exports.DocumentMimeType = void 0;
exports.DocumentMimeType = {
    PDF: 'application/pdf',
    WORD: 'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
    POWERPOINT: 'application/vnd.openxmlformats-officedocument.presentationml.presentation',
};
exports.WORD_AND_PDF_MIME_TYPES = [
    exports.DocumentMimeType.WORD,
    exports.DocumentMimeType.PDF,
];
exports.WORD_AND_POWERPOINT_MIME_TYPES = [
    exports.DocumentMimeType.WORD,
    exports.DocumentMimeType.POWERPOINT,
];
//# sourceMappingURL=documentMimeTypes.constant.js.map